import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = { class: "alert alert-danger mb-0" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"card h-100\"><div class=\"card-body\"><div class=\"placeholder-glow\"><span class=\"placeholder col-6\"></span><span class=\"placeholder col-4 d-block mt-3\" style=\"height:2rem;\"></span></div></div></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "card h-100" }
const _hoisted_7 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "fs-6 text-muted" }
const _hoisted_9 = { class: "fs-2 fw-bold" }
const _hoisted_10 = { class: "fs-7 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "KPIs failed to load: " + _toDisplayString(_ctx.error), 1)
        ]))
      : (_ctx.loading && !_ctx.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(4, (n) => {
            return _createElementVNode("div", {
              class: "col-md-3 mb-5 mb-md-0",
              key: n
            }, _hoisted_5)
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.cards, (card) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-3 mb-5 mb-md-0",
              key: card.label
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(card.label), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(card.value), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(card.hint), 1)
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass([card.icon, "fs-1"]),
                    style: {"color":"#f50242"}
                  }, null, 2)
                ])
              ])
            ]))
          }), 128))
  ]))
}